const ROLES = {
    ADMIN: 'ADMIN',
    EMPLOYEE: 'EMPLOYEE', 
    CUSTOMER: 'CUSTOMER',
}

export default ROLES;